import React, { useState, useEffect, ChangeEvent } from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TimePeriodSelectorProps {
  onChange: (isoDuration: string) => void;
}

export const TimePeriodSelector: React.FC<TimePeriodSelectorProps> = ({
  onChange,
}: TimePeriodSelectorProps) => {
  const { t } = useTranslation();

  const [years, setYears] = useState(1);
  const [months, setMonths] = useState(0);
  const [days, setDays] = useState(0);
  const [error, setError] = useState(false);

  useEffect(() => {
    const duration = `P${years}Y${months}M${days}D`; // ISO 8601 Duration

    const isAllZero = years === 0 && months === 0 && days === 0;

    if (isAllZero) {
      setError(true);
    } else {
      setError(false);
      onChange(duration);
    }
  }, [years, months, days]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-4 items-end">
        <TextField
          label={t('years')}
          size="small"
          type="number"
          value={years}
          inputProps={{ min: 0 }}
          onChange={(e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void =>
            setYears(parseInt(e.target.value) || 0)
          }
        />
        <TextField
          label={t('months')}
          size="small"
          type="number"
          value={months}
          inputProps={{ min: 0 }}
          onChange={(e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void =>
            setMonths(parseInt(e.target.value) || 0)
          }
        />
        <TextField
          label={t('days')}
          size="small"
          type="number"
          value={days}
          inputProps={{ min: 0 }}
          onChange={(e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void =>
            setDays(parseInt(e.target.value) || 0)
          }
        />
      </div>
      {error && <p className="text-red-600 text-sm">{t('provide_period')}</p>}
    </div>
  );
};
